<template>
  <div>
    <div
    v-if="
      $route.path.indexOf('_detail') === -1 &&$route.path.indexOf('_edit') === -1
    "
  >
    <el-row :gutter="24">
      <el-col :span="3">
        <el-input
          placeholder="充值卡前段码"
          v-model="params.frist_num"
          style="width: 100%"
          size="mini"
        ></el-input>
      </el-col>

      <el-col :span="6">
        <el-button type="primary" @click="searchData" size="mini"
          >搜索</el-button
        >
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="24">
        <el-button type="primary" @click="toAdd()" size="mini">新增+</el-button>
      </el-col>
    </el-row>
    <el-table :data="dataList" :height="wheight - 130" v-loading="loading">
      <el-table-column
        prop="card_type_text"
        label="e卡通类型"
      ></el-table-column>
      <el-table-column prop="frist_num" label="充值卡前段码"></el-table-column>
      <el-table-column
        prop="card_rmb_text"
        label="现金面额"
      ></el-table-column>
      <el-table-column
        prop="card_currency_num_text"
        label="康币面额"
      ></el-table-column>
      <el-table-column
        prop="total_count"
        label="发卡数量"
      ></el-table-column>
      <el-table-column
        prop="unused_count"
        label="未使用数量"
      ></el-table-column>
      <el-table-column
        prop="used_count"
        label="已使用数量"
      ></el-table-column>
      <el-table-column
        prop="void_count"
        label="已废弃数量"
      ></el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <el-tag
              size="mini"
              effect="plain"
              @click="edit(scope.row)"
              >编辑</el-tag
            >
            <el-tag
              size="mini"
              effect="plain"
              type="danger"
              @click="del(scope.row.card_type_id,scope.$index)"
              >删除</el-tag
            >
          </template>
        </el-table-column>
    </el-table>
    <div class="content-center content-top-padded">
      <el-pagination
        background
        layout="total, sizes, prev, pager, next"
        @current-change="handleCurrentChange"
        @size-change="handleSizeChange"
        :current-page.sync="params.page"
        :page-sizes="[10, 20, 50]"
        :total="total_count"
        :page-size="params.pagesize"
      >
      </el-pagination>
    </div>
      <div>
        <el-dialog
          :title="title"
          :visible.sync="dialogVisible"
          width="30%"
          :before-close="handleClose">
          <el-form  :model="form" class="demo-form-inline">

            <el-form-item label="卡通类型">
              <el-select v-model="form.card_type" placeholder="e卡通类型">
                <el-option label="A" value="A"></el-option>
                <el-option label="B" value="B"></el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="充值卡前段码">
              <el-input v-model.number="form.frist_num"   placeholder="充值卡前段码"></el-input>
            </el-form-item>
            <el-form-item label="现金面额">
              <el-input v-model.number="form.card_rmb" placeholder="现金面额"></el-input>
            </el-form-item>
            <el-form-item label="康币面额">
              <el-input v-model.number="form.card_currency_num" placeholder="康币面额"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="onSubmit" >确认保存</el-button>
            </el-form-item>
          </el-form>
        </el-dialog>
      </div>
  </div>
   <router-view></router-view>
  </div>
</template><script>
import { mapGetters } from "vuex";
import {
  createEcardType,
  updateEcardType,
  deleteEcardType,
  getEcardTypeList,
} from "../../../api/member";

export default {
  components: {},
  data() {
    return {
      total_count: 0,
      params: {
        page: 1,
        pagesize: 20,
      },
      dataList: [],
      loading: false,
      dialogVisible:false,
      title:'创建',
      form:{
        card_type:"B",
        frist_num:'',
        card_rmb:'',
        card_currency_num:'0.00'
      },
    };
  },
  computed: {
    ...mapGetters(["wheight"]),
  },
  methods: {
    handleClose(){
       this.dialogVisible=false;
    },
    toAdd() {
        this.dialogVisible=true;

    },
    edit(row) {
      this.title='编辑',
      this.dialogVisible=true;
      this.form = row;
    },
    onSubmit(){
      if(this.form.card_type_id >0){
         var oldForm = this.form;
          updateEcardType(this.form.card_type_id,this.form).then((res)=>{
              this.$message({
                message: res.data.data.msg,
                type: res.data.data.status ? "success":"error",
                duration: 2000,
              });
              if(res.data.data.status){
                setTimeout(()=>{
                   this.dialogVisible=false;
                   this.params.page = 1;
                   this.getDataList();
                },1000)
              }
          })

      }else{
          createEcardType(this.form).then((res)=>{
              this.$message({
                message:res.data.data.msg,
                type: res.data.data.status ? "success":"error",
                duration: 2000,
              });
              if(res.data.data.status){
                setTimeout(()=>{
                   this.dialogVisible=false;
                   this.params.page = 1;
                   this.getDataList();
                },1000)
              }
          })
      }

    },
     del(id, index) {
      var that = this;
      this.$confirm("确定要删除？", "提示", {
        cancelButtonText: "取消",
        confirmButtonText: "确定",
        type: "warning",
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            deleteEcardType(id).then((res) => {
              if (res.status) {
                this.$message({
                  message: "已删除",
                  type: "success",
                  duration: 2000,
                });
                setTimeout(function () {
                  that.dataList.splice(index, 1);
                }, 1000);
              }
            });
          }
          done();
        },
      });
    },
    getDataList() {
      this.loading = true;
      getEcardTypeList(this.params)
        .then((response) => {
          this.dataList = response.data.data.list;
          this.total_count = response.data.data.total_count;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          this.$message({
            type: "error",
            message: "获取列表信息出错",
          });
        });
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num;
      this.getDataList();
    },
    searchData() {
      this.params.page = 1;
      this.getDataList();
    },
    handleSizeChange(pageSize) {
      this.params.page = 1;
      this.params.pagesize = pageSize;
      this.getDataList();
    },
  },
  mounted() {
    this.getDataList();
  },
};
</script>
<style scoped lang="scss">
.el-row {
  margin-bottom: 20px;
  &:last-child {
    margin-bottom: 0;
  }
  img {
    width: 90%;
  }
}
.el-col {
  border-radius: 4px;
}
.bg-purple-dark {
  background: #99a9bf;
}
.bg-purple {
  background: #d3dce6;
}
.bg-purple-light {
  background: #e5e9f2;
}
.grid-content {
  border-radius: 4px;
  min-height: 10px;
  img {
    width: 90%;
  }
}
.row-bg {
  padding: 10px 20px;
  background-color: #f9fafc;
}
</style>



// WEBPACK FOOTER //
// ecardtype.vue?7e1b60b0